const PROMISES = [
  {
    title: "1对1管家找房",
    desc: "为你避坑,替你谈判。",
    tone: "forest" as const,
    icon: "user",
  },
  {
    title: "新加坡安家全程陪伴",
    desc: "为你消除对陌生环境的焦虑。",
    tone: "coral" as const,
    icon: "home",
  },
  {
    title: "退房全程指导",
    desc: "协助搬家,避免被房东扣押金。",
    tone: "gold" as const,
    icon: "check",
  },
];

const TONE_STYLES = {
  forest: "bg-forest-100 text-forest-800",
  coral: "bg-coral-100 text-coral-700",
  gold: "bg-gold-100 text-gold-700",
};

export function TrustPromise() {
  return (
    <div className="px-5">
      <div className="relative overflow-hidden rounded-[28px] border border-coral-100 bg-gradient-to-br from-coral-50 to-paper px-[22px] pb-5 pt-6">
        <div
          className="pointer-events-none absolute -right-10 -top-10 h-[200px] w-[200px] rounded-full opacity-50"
          style={{
            background:
              "radial-gradient(circle, rgb(219 240 228), transparent 70%)",
          }}
          aria-hidden
        />
        <div className="trust-pill relative mb-4">
          <span className="dot" />
          核心承诺 · CORE
        </div>
        <h3 className="relative mb-5 text-2xl font-bold leading-[1.25] tracking-tight text-ink-900">
          三句话讲清,
          <br />
          <span className="text-coral-700">我们为你做什么。</span>
        </h3>
        <ul className="relative flex flex-col gap-3">
          {PROMISES.map((p) => (
            <li
              key={p.title}
              className="flex items-center gap-3.5 rounded-[18px] border border-[var(--line-soft)] bg-paper p-4 shadow-card"
            >
              <div
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-[14px] ${TONE_STYLES[p.tone]}`}
              >
                <PromiseIcon type={p.icon} />
              </div>
              <div>
                <p className="text-base font-bold tracking-tight text-ink-900">
                  {p.title}
                </p>
                <p className="mt-0.5 text-[12.5px] leading-snug text-ink-500">
                  {p.desc}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function PromiseIcon({ type }: { type: string }) {
  if (type === "user") {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
        <circle cx="11" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M3 19c1.5-3.5 4.5-5 8-5s6.5 1.5 8 5"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (type === "home") {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
        <path
          d="M3 11l8-7 8 7v8a1 1 0 01-1 1h-4v-6h-6v6H4a1 1 0 01-1-1v-8z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
      <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M7 11l3 3 5-6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
